import React, { useState, useEffect } from 'react';
import Bio from './Bio';
// import Galery from './Galery';
import Header from './Header';
import Contact from './Contact';
import '../styles/index.css';
import BussinesOffer from './BussinesOffer';
import ClientsSlider from './ClientsSlider';
import WhatsappIcon from './WhatsappIcon';
import Footer from './Footer';
// import Team from './Team';
import Policy from './Policy';
import PrivacyBanner from './PrivacyBanner';
import { GuiarMetrics } from '../utils/metrics';

const Aplication = () => {
    const [route, setRoute] = useState(window.location.hash || '#/');

    useEffect(() => {
        // Initial page view
        GuiarMetrics.trackPageView(window.location.hash || '#/', document.title);

        const handleHashChange = () => {
            const currentRoute = window.location.hash || '#/';
            setRoute(currentRoute);
            // Scroll to top on route change
            window.scrollTo(0, 0);

            // Track page view on change
            const pageTitle = currentRoute === '#/politica' ? 'Política de Privacidad' : document.title;
            GuiarMetrics.trackPageView(currentRoute, pageTitle);
        };

        window.addEventListener('hashchange', handleHashChange);
        return () => window.removeEventListener('hashchange', handleHashChange);
    }, []);

    const renderContent = () => {
        if (route === '#/politica') {
            return <Policy />;
        }

        return (
            <>
                <Header />
                <Bio />
                {/* <Galery /> */}
                <BussinesOffer />
                <ClientsSlider />
                {/* <Team /> */}
                <Contact />
                <Footer />
                <WhatsappIcon />
            </>
        );
    };

    return (
        <div>
            {renderContent()}
            <PrivacyBanner />
        </div>
    );
};

export default Aplication;

